import { useEffect } from 'react';

/**
 * Set document.title for the page's lifetime (Strangler Fig parity: the Backbone
 * pages set per-page <title> via Django templates; React must match). Restores the
 * previous title on unmount.
 */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    const prev = document.title;
    document.title = title;
    return () => {
      document.title = prev;
    };
  }, [title]);
}
